import { RecurringPaymentOption } from '../utils/checkoutState';

const initialRecurringPaymentMethods: RecurringPaymentOption[] = [
  {
    recurringPaymentOptionId: '8c40fe1e059199d1164fbdf5a83fa291',
    paymentOptionKey: 'paypal_instant',
    paymentOptionProvider: 'paypal',
    recurringPaymentInformation: {
      customerEmail: 't**t@**************g.*e'
    },
    isDisabled: false
  },
  {
    recurringPaymentOptionId: '4817cb0cc6a2b9b601454789d6c62cb8',
    paymentOptionKey: 'computop_creditcard',
    paymentOptionProvider: 'computop',
    recurringPaymentInformation: {
      maskedCreditcardNumber: 'XXXXXXXXXXXX1234'
    },
    isDisabled: false
  },
  {
    recurringPaymentOptionId: '4817cb0cc6a2b9b601454789d6c62cba',
    paymentOptionKey: 'klarna_paylater',
    paymentOptionProvider: 'klarna',
    recurringPaymentInformation: {
      customerEmail: 't**t@**************g.*e'
    },
    isDisabled: false
  }
];

export default initialRecurringPaymentMethods;
